import { Pipe, NgModule } from '@angular/core';

/**
 * Shared service for providing configurations between remote applications.
 * The implementation should be provided by the root module of the Shell.
 */
import * as ɵngcc0 from '@angular/core';
class ConfigurationService {
}

class AbsoluteUrlPipe {
    constructor(_configurationService) {
        this._configurationService = _configurationService;
    }
    transform(relativePath, subsystemKey) {
        var basePath = this._configurationService.getStaticUrl(subsystemKey);
        return `${basePath}/${relativePath}`;
    }
}
AbsoluteUrlPipe.ɵfac = function AbsoluteUrlPipe_Factory(t) { return new (t || AbsoluteUrlPipe)(ɵngcc0.ɵɵdirectiveInject(ConfigurationService, 16)); };
AbsoluteUrlPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "absoluteUrl", type: AbsoluteUrlPipe, pure: true });
AbsoluteUrlPipe.ctorParameters = () => [
    { type: ConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbsoluteUrlPipe, [{
        type: Pipe,
        args: [{
                name: 'absoluteUrl'
            }]
    }], function () { return [{ type: ConfigurationService }]; }, null); })();

class DsPortalCommonModule {
}
DsPortalCommonModule.ɵfac = function DsPortalCommonModule_Factory(t) { return new (t || DsPortalCommonModule)(); };
DsPortalCommonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DsPortalCommonModule });
DsPortalCommonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DsPortalCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [AbsoluteUrlPipe],
                imports: [],
                exports: [AbsoluteUrlPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsPortalCommonModule, { declarations: [AbsoluteUrlPipe], exports: [AbsoluteUrlPipe] }); })();

class ErrorHandlerService {
}

/**
 * Shared service for providing current identity between remote applications.
 * The implementation should be provided by the root module of the Shell.
 */
class IdentityProviderService {
}

class LocalizationService {
}

/*
 * Public API Surface of ds-portal-common
 */
//export * from './lib/utils/devextreme-shared-deps-builder.js';

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigurationService, DsPortalCommonModule, ErrorHandlerService, IdentityProviderService, LocalizationService, AbsoluteUrlPipe as ɵa };

